<ng-container [ngSwitch]="entitlement.entitlement">
  <!-- Secondary users -->
  <ng-container *ngSwitchCase="entitlements.MaxSecondaryUsers">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>
          You need to delete {{ entitlement.disable }} secondary {{ 'users' | pluralize: entitlement.disable }}
        </ng-container>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>

  <!-- Active properties -->
  <ng-container *ngSwitchCase="entitlements.Properties">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>
          You need to mute {{ entitlement.disable }} {{ 'properties' | pluralize: entitlement.disable }}
        </ng-container>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>

  <!-- Direct -->
  <ng-container *ngSwitchCase="entitlements.Direct">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>Direct booking sites and widgets will be deactivated</ng-container>
        <div class="italic">Current direct bookings at active properties will not be impacted</div>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>

  <!-- Smart devices -->
  <ng-container *ngSwitchCase="entitlements.SmartDevices">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>Managed smart device accounts will be removed</ng-container>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>

  <!-- Parent child -->
  <ng-container *ngSwitchCase="entitlements.ParentChild">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>All parent-child configurations will be removed</ng-container>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>

  <!-- Owner statements -->
  <ng-container *ngSwitchCase="entitlements.OwnerStatements">
    <div class="downgrade-warning">
      <sbnb-downgrade-warning-item>
        <ng-container title>Owner Statements will be unavailable for all but one property.</ng-container>
      </sbnb-downgrade-warning-item>
      <sbnb-downgrade-warning-item>
        <ng-container title>Accounting software will be disconnected from Owner Statements.</ng-container>
      </sbnb-downgrade-warning-item>
    </div>
  </ng-container>
</ng-container>
